import { SVGViewerParent } from "../ManufacturersPanelStyles";
import SVGViewer from "../../common/SVGViewer";
import React from "react";
import { SVG } from "@svgdotjs/svg.js";

export interface XYCoordinate {
  x: number;
  y: number;
}

export interface Box {
  minX: number;
  minY: number;
  width: number;
  height: number;
}

export default function PanelRendering({
  panel,
  boards,
  elementCoords,
  fiducialLocations,
}: {
  panel: Box;
  boards: Box[];
  elementCoords: XYCoordinate[];
  fiducialLocations: XYCoordinate[];
}) {
  // Prepare the canvas and viewbox
  const svgDrawing = SVG().size(panel.width, panel.height);
  svgDrawing.viewbox(panel.minX, panel.minY, panel.width, panel.height);

  // Draw the panel
  svgDrawing
    .rect(panel.width, panel.height)
    .move(panel.minX, panel.minY)
    .attr({ fill: "#2B47EE" });

  boards.forEach((board) => {
    svgDrawing
      .rect(board.width, board.height)
      .move(board.minX, panel.minY + panel.height - board.minY - board.height)
      .fill("#47ee2b")
      .stroke({ color: "#156208", width: 0.25 });
  });

  elementCoords.forEach(({ x, y }) => {
    svgDrawing
      .circle(1)
      .move(x - 0.5, panel.minY + panel.height - y - 0.5)
      .fill("#EE2B47");
  });

  fiducialLocations.forEach(({ x, y }) => {
    svgDrawing
      .circle(1)
      .move(x - 0.5, panel.minY + panel.height - y - 0.5)
      .fill("#EE702B");
  });

  return (
    <SVGViewerParent>
      <SVGViewer
        svgInput={{ svg: svgDrawing.svg() }}
        inert
        title={"From top of panel"}
      />
    </SVGViewerParent>
  );
}
